/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxmUserauthV1TenantEvent } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXM_USERAUTH_V1_TENANT_EVENT_ENTITY_NAME = 'ixm.userauth.v1.TenantEvent';
export const ixmUserauthV1TenantEventEntity = new schema.Entity<IxmUserauthV1TenantEvent>(IXM_USERAUTH_V1_TENANT_EVENT_ENTITY_NAME, {}, { idAttribute: (entity: IxmUserauthV1TenantEvent) => `${entity.metadata?.eventId}` });

